
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../AddressFinder/AddressFinderTypes";
import OccurrenceHome from '../OccurrenceHome';
class MasterTemplateHome_Simple_OLD extends compose(OccurrenceHome) {

  

    // --------------------own methods ----------------------------end

    postCreate(): void {

        this._customFinderSetupConfig = {
            configCallfunction: "Webtool_MasterTemplates_API__GetFilterOptions",
            filterdataCallfunction: "Webtool_MasterTemplates_API__GetResultList",
            additionalRequestData: [{
                name: "mode",
                value: "simple"
            }]
        }
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MasterTemplateHome_Simple_OLD);